/**
 * Mixin para proteger modais de fechamento acidental quando há dados não salvos.
 * Detecta alterações comparando o estado inicial com o estado atual.
 */
export default {
  data() {
    return {
      initialFormState: null,
      showUnsavedChangesConfirm: false,
      pendingCloseCallback: null,
    };
  },

  methods: {
    /**
     * Captura o estado inicial do formulário para comparação futura.
     * Deve ser chamado após inicializar os dados do formulário.
     * @param {Object} formState - Objeto representando o estado do formulário
     */
    captureInitialState(formState) {
      this.initialFormState = JSON.stringify(formState);
    },

    /**
     * Verifica se há alterações não salvas comparando estado atual com inicial.
     * @param {Object} currentState - Estado atual do formulário
     * @returns {Boolean} true se há alterações, false caso contrário
     */
    hasUnsavedChanges(currentState) {
      if (!this.initialFormState) {
        return false;
      }
      const hasChanges = JSON.stringify(currentState) !== this.initialFormState;
      return hasChanges;
    },

    /**
     * Intercepta tentativa de fechamento do modal.
     * Se houver alterações, mostra confirmação. Se não, fecha normalmente.
     * @param {Object} currentState - Estado atual do formulário
     * @param {Function} closeCallback - Função original de fechamento
     * @param {Function} confirmCallback - Função para mostrar modal de confirmação (opcional)
     * @returns {Boolean} true se o fechamento pode prosseguir, false se foi interceptado
     */
    handleUnsavedClose(currentState, closeCallback, confirmCallback = null) {
      const hasChanges = this.hasUnsavedChanges(currentState);

      if (!hasChanges) {
        // Sem alterações, permite fechamento normal
        closeCallback();
        return true;
      }

      // Há alterações, precisa de confirmação
      if (confirmCallback) {
        // Usa callback customizado (para integração com woot-delete-modal)
        this.pendingCloseCallback = closeCallback;
        confirmCallback();
      } else {
        // Usa confirm nativo do browser
        const message = this.$t('CONFIRM_UNSAVED_CHANGES.MESSAGE') ||
                       'Existem alterações não salvas. Deseja realmente sair?';
        if (window.confirm(message)) {
          closeCallback();
          return true;
        }
      }
      return false;
    },

    /**
     * Confirma o fechamento após confirmação do usuário.
     */
    confirmUnsavedClose() {
      this.showUnsavedChangesConfirm = false;
      if (this.pendingCloseCallback) {
        this.pendingCloseCallback();
        this.pendingCloseCallback = null;
      }
    },

    /**
     * Cancela o fechamento e mantém o modal aberto.
     */
    cancelUnsavedClose() {
      this.showUnsavedChangesConfirm = false;
      this.pendingCloseCallback = null;
    },
  },
};
